import ReportingView from './ReportingView';

export default ReportingView;



// WEBPACK FOOTER //
// ./src/views/payoutsAndTaxes/reporting/index.js